import { History } from "history";

import {
  ADD_UPDATE_OLYMPIC,
  ADD_UPDATE_OLYMPIC_ERROR,
  ADD_UPDATE_OLYMPIC_SUCCESS,
  AddUpdateOlympicAction,
  AddUpdateOlympicErrorAction,
  AddUpdateOlympicSuccessAction,
  DELETE_OLYMPIC,
  DELETE_OLYMPIC_CONSENT,
  DELETE_OLYMPIC_ERROR,
  DELETE_OLYMPIC_QUESTION,
  DELETE_OLYMPIC_QUESTION_CONSENT,
  DELETE_OLYMPIC_QUESTION_ERROR,
  DELETE_OLYMPIC_QUESTION_SUCCESS,
  DELETE_OLYMPIC_SUCCESS,
  DeleteOlympicAction,
  DeleteOlympicErrorAction,
  DeleteOlympicSuccessAction,
  GET_OLYMPIC,
  GET_OLYMPICS,
  GET_OLYMPICS_ERROR,
  GET_OLYMPICS_SUCCESS,
  GET_OLYMPIC_ERROR,
  GET_OLYMPIC_PARTICIPANTS,
  GET_OLYMPIC_PARTICIPANTS_ERROR,
  GET_OLYMPIC_PARTICIPANTS_SUCCESS,
  GET_OLYMPIC_SUCCESS,
  GetOlympicAction,
  GetOlympicErrorAction,
  GetOlympicParticipantsAction,
  GetOlympicParticipantsErrorAction,
  GetOlympicParticipantsSuccessAction,
  GetOlympicSuccessAction,
  GetOlympicsAction,
  GetOlympicsErrorAction,
  GetOlympicsSuccessAction,
  TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL,
  ToggleAddEditOlympicQuestionModalAction,
  UPDATE_OLYMPIC_QUESTION,
  UPDATE_OLYMPIC_QUESTION_ERROR,
  UPDATE_OLYMPIC_QUESTION_SUCCESS,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS,
  UploadOlympicQuestionDisplayImageAction,
  UploadOlympicQuestionDisplayImageErrorAction,
  UploadOlympicQuestionDisplayImageSuccessAction,
} from "./actionTypes";
import {
  GetQuestionsByOlympicAction,
  GET_QUESTIONS_BY_OLYMPIC,
  GetQuestionsByOlympicSuccessAction,
  GET_QUESTIONS_BY_OLYMPIC_SUCCESS,
  GetQuestionsByOlympicErrorAction,
  GET_QUESTIONS_BY_OLYMPIC_ERROR,
  AddOlympicQuestionAction,
  AddOlympicQuestionErrorAction,
  AddOlympicQuestionSuccessAction,
  DeleteOlympicQuestionAction,
  DeleteOlympicQuestionConsentAction,
  DeleteOlympicQuestionErrorAction,
  DeleteOlympicQuestionSuccessAction,
  GetOlympicQuestionAction,
  GetOlympicQuestionErrorAction,
  GetOlympicQuestionSuccessAction,
  UpdateOlympicQuestionAction,
  UpdateOlympicQuestionErrorAction,
  UpdateOlympicQuestionSuccessAction,
  GET_OLYMPIC_QUESTION,
  ADD_OLYMPIC_QUESTION,
  ADD_OLYMPIC_QUESTION_ERROR,
  ADD_OLYMPIC_QUESTION_SUCCESS,
  GET_OLYMPIC_QUESTION_ERROR,
  GET_OLYMPIC_QUESTION_SUCCESS,
} from "./actionTypes";
import { MediaDto } from "../../interfaces/media";
import {
  CreateUpdateOlympicRequest,
  CreateOlympicQuestionRequest,
  OlympicQuestionDto,
  UpdateOlympicQuestionRequest,
  OlympicDto,
  OlympicParticipantDto,
} from "../../interfaces/olympic";
import { PaginateQuery, Paginated } from "../../models";

//#region Olympic Question

//#region Get Questions by Grade

export const getQuestionsByOlympic = (
  query: PaginateQuery
): GetQuestionsByOlympicAction => {
  return {
    type: GET_QUESTIONS_BY_OLYMPIC,
    payload: { query },
  };
};

export const getQuestionsByOlympicSuccess = (
  response: OlympicQuestionDto[]
): GetQuestionsByOlympicSuccessAction => {
  return {
    type: GET_QUESTIONS_BY_OLYMPIC_SUCCESS,
    payload: response,
  };
};

export const getQuestionsByOlympicError = (
  error: any
): GetQuestionsByOlympicErrorAction => {
  return {
    type: GET_QUESTIONS_BY_OLYMPIC_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Olympic Question

export const getOlympicQuestion = (
  id: string,
  history: History
): GetOlympicQuestionAction => {
  return {
    type: GET_OLYMPIC_QUESTION,
    payload: { id, history },
  };
};

export const getOlympicQuestionSuccess = (
  response: OlympicQuestionDto
): GetOlympicQuestionSuccessAction => {
  return {
    type: GET_OLYMPIC_QUESTION_SUCCESS,
    payload: response,
  };
};

export const getOlympicQuestionError = (
  error: any
): GetOlympicQuestionErrorAction => {
  return {
    type: GET_OLYMPIC_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Olympic Question

export const addOlympicQuestion = (
  request: CreateOlympicQuestionRequest,
  history: History
): AddOlympicQuestionAction => {
  return {
    type: ADD_OLYMPIC_QUESTION,
    payload: { request, history },
  };
};

export const addOlympicQuestionSuccess =
  (): AddOlympicQuestionSuccessAction => {
    return {
      type: ADD_OLYMPIC_QUESTION_SUCCESS,
      payload: null,
    };
  };

export const addOlympicQuestionError = (
  error: any
): AddOlympicQuestionErrorAction => {
  return {
    type: ADD_OLYMPIC_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Olympic Question

export const updateOlympicQuestion = (
  id: string,
  request: UpdateOlympicQuestionRequest,
  history: History
): UpdateOlympicQuestionAction => {
  return {
    type: UPDATE_OLYMPIC_QUESTION,
    payload: { id, request, history },
  };
};

export const updateOlympicQuestionSuccess =
  (): UpdateOlympicQuestionSuccessAction => {
    return {
      type: UPDATE_OLYMPIC_QUESTION_SUCCESS,
      payload: null,
    };
  };

export const updateOlympicQuestionError = (
  error: any
): UpdateOlympicQuestionErrorAction => {
  return {
    type: UPDATE_OLYMPIC_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Olympic Question

export const deleteOlympicQuestionConsent = (
  id: string
): DeleteOlympicQuestionConsentAction => {
  return {
    type: DELETE_OLYMPIC_QUESTION_CONSENT,
    payload: id,
  };
};

export const deleteOlympicQuestion = (
  id: string,
  history: History
): DeleteOlympicQuestionAction => {
  return {
    type: DELETE_OLYMPIC_QUESTION,
    payload: { id, history },
  };
};

export const deleteOlympicQuestionSuccess =
  (): DeleteOlympicQuestionSuccessAction => {
    return {
      type: DELETE_OLYMPIC_QUESTION_SUCCESS,
      payload: null,
    };
  };

export const deleteOlympicQuestionError = (
  error: any
): DeleteOlympicQuestionErrorAction => {
  return {
    type: DELETE_OLYMPIC_QUESTION_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Olympic Question Home Image

export const uploadOlympicQuestionDisplayImage = (
  file: File,
  history: History,
  questionId?: string
): UploadOlympicQuestionDisplayImageAction => {
  return {
    type: UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE,
    payload: { file, history, questionId },
  };
};

export const uploadOlympicQuestionDisplayImageSuccess = (
  media: MediaDto
): UploadOlympicQuestionDisplayImageSuccessAction => {
  return {
    type: UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadOlympicQuestionDisplayImageError = (
  error: any
): UploadOlympicQuestionDisplayImageErrorAction => {
  return {
    type: UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Edit Olympic question modal
export const toggleAddEditOlympicQuestionModal =
  (): ToggleAddEditOlympicQuestionModalAction => {
    return {
      type: TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL,
      payload: null,
    };
  };
//#endregion

//#endregion

//#region Olympic

//#region Get Olympic

export const getOlympic = (id: string, history: History): GetOlympicAction => {
  return {
    type: GET_OLYMPIC,
    payload: { id, history },
  };
};

export const getOlympicSuccess = (
  response: OlympicQuestionDto
): GetOlympicSuccessAction => {
  return {
    type: GET_OLYMPIC_SUCCESS,
    payload: response,
  };
};

export const getOlympicError = (error: any): GetOlympicErrorAction => {
  return {
    type: GET_OLYMPIC_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Update Olympic

export const addUpdateOlympic = (
  request: CreateUpdateOlympicRequest,
  history: History
): AddUpdateOlympicAction => {
  return {
    type: ADD_UPDATE_OLYMPIC,
    payload: { request, history },
  };
};

export const addUpdateOlympicSuccess = (): AddUpdateOlympicSuccessAction => {
  return {
    type: ADD_UPDATE_OLYMPIC_SUCCESS,
    payload: null,
  };
};

export const addUpdateOlympicError = (
  error: any
): AddUpdateOlympicErrorAction => {
  return {
    type: ADD_UPDATE_OLYMPIC_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Olympics

export const getOlympics = (query: PaginateQuery): GetOlympicsAction => {
  return {
    type: GET_OLYMPICS,
    payload: { query },
  };
};

export const getOlympicsSuccess = (
  response: Paginated<OlympicDto>
): GetOlympicsSuccessAction => {
  return {
    type: GET_OLYMPICS_SUCCESS,
    payload: response,
  };
};

export const getOlympicsError = (error: any): GetOlympicsErrorAction => {
  return {
    type: GET_OLYMPICS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Olympic

export const deleteOlympicConsent = (
  id: string
): DeleteOlympicQuestionConsentAction => {
  return {
    type: DELETE_OLYMPIC_CONSENT,
    payload: id,
  };
};

export const deleteOlympic = (id: string): DeleteOlympicAction => {
  return {
    type: DELETE_OLYMPIC,
    payload: { id },
  };
};

export const deleteOlympicSuccess = (): DeleteOlympicSuccessAction => {
  return {
    type: DELETE_OLYMPIC_SUCCESS,
    payload: null,
  };
};

export const deleteOlympicError = (error: any): DeleteOlympicErrorAction => {
  return {
    type: DELETE_OLYMPIC_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Olympic Participants

export const getOlympicParticipants = (
  request: PaginateQuery,
  history: History
): GetOlympicParticipantsAction => {
  return {
    type: GET_OLYMPIC_PARTICIPANTS,
    payload: { request, history },
  };
};

export const getOlympicParticipantsSuccess = (
  response: Paginated<OlympicParticipantDto>
): GetOlympicParticipantsSuccessAction => {
  return {
    type: GET_OLYMPIC_PARTICIPANTS_SUCCESS,
    payload: response,
  };
};

export const getOlympicParticipantsError = (
  error: any
): GetOlympicParticipantsErrorAction => {
  return {
    type: GET_OLYMPIC_PARTICIPANTS_ERROR,
    payload: error,
  };
};

//#endregion
